import * as React from "react";
import Modal from "react-modal";
import styled, { withTheme, ThemeProps } from "styled-components";
import { Button } from "react-bootstrap";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { ITheme } from "../../../themes/types";

export const modalStyles = {
  content: {
    width: "80%",
    maxWidth: "500px",
    height: "fit-content",
    position: "unset",
    background: "",
    color: ""
  },
  overlay:{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  }
}

export const ModalTitle = styled.div`
  padding: 15px;
`;

export const H2 = styled.h2`
  text-transform: lowercase;
  &::first-letter{
    text-transform: uppercase;
  }
`;

export const ModalBody = styled.div`
  padding: 0 30px;
  @media only screen and (max-width: 557px) {
    padding: 0px;
  }
`;

export const ModalFooter = styled.div`
  margin: 20px 15px;
  padding: 15px;
  text-align: right;
  @media only screen and (min-width: 558px) {
    margin: 20px 55px;
  }
  @media only screen and (max-width: 557px) {
    margin: 20px 27px;
  }
`;

export const ConfirmBtn = styled(Button)`
  background: #F12638;
  color: white;
  margin-right: 10px;
  min-width: 200px;
  float: left;
  @media only screen and (max-width: 557px) {
    min-width: 165px;
  }
`;

export const CancelButton = styled(Button)`
  color: white;
  background: ${props => props.theme.colors.borderColor};
  margin-right: 15px;
  float: left;
  @media only screen and (max-width: 557px) {
    min-width: 165px;
    margin-right: 10px;
    margin-bottom: 5px;
  }
`;


export interface MapConfirmModalProps{
  title: string | null;
  body: string | JSX.Element | null;
  afterFooter: string | JSX.Element | null;
  info?: boolean;
  confirmText?: string;
  confirmFunc?: Function;
  maxWidth?: string;
  disableClose?: boolean;
}

export interface ExtendedMapConfirmModalProps extends MapConfirmModalProps, ThemeProps<ITheme>, WrappedComponentProps{

}

const mapConfirmModal = () => {
  
  const [ open, setOpen ] = React.useState(false);
  Modal.setAppElement("#react");

  return{Comp: injectIntl(withTheme(({theme, maxWidth, title, body, afterFooter, info, confirmText, confirmFunc, disableClose, intl: {formatMessage}}: ExtendedMapConfirmModalProps) => (
    <Modal
      isOpen={open}
      onRequestClose={() => {
        if(!disableClose)
          setOpen(false)
      }}
      style={
        {
          content: {
            maxWidth,
            width: "80%",
            height: "fit-content",
            position: "unset",
            background: theme.colors.backgroundPrimary,
            color: ""
          },
          overlay:{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }
        }
      }
    >
      {title &&
      <ModalTitle>
        <H2>{title}</H2>
      </ModalTitle>}
      {body &&
      <ModalBody>
        {body}
      </ModalBody>}
      <ModalFooter>
        {info 
          ? 
            <CancelButton onClick={() => setOpen(false)}>
              {formatMessage({id: "ok", defaultMessage: "OK"})}
            </CancelButton>
          :
            <React.Fragment>
              <ConfirmBtn onClick={() => {confirmFunc && confirmFunc(); setOpen(false)}}>
                {confirmText}
              </ConfirmBtn>
            </React.Fragment>
        }
      </ModalFooter>
      {afterFooter && 
        <ModalBody>
          {afterFooter}
        </ModalBody>}
    </Modal>
  ))), func: setOpen}
}

export default mapConfirmModal;